import React from 'react';
import {Link} from 'react-router-dom';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import '../../styles/Example.scss';
import { 
            makeStyles,
            GridList,
            GridListTile,
            Typography,
            IconButton,
            Button,
        } from '@material-ui/core';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '40px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
}));


function NewGrid(props) {
  const classes = useStyles();

  const getGridListCols = () => {
    if (isWidthUp('xl', props.width)) {
      return 4;
    }

    if (isWidthUp('lg', props.width)) {
      return 4;
    }

    if (isWidthUp('md', props.width)) {
      return 2;
    }

    return 1;
  }
 
  return (
    <div className={classes.root}>
      <GridList cellHeight={340} className='gridList' cols={getGridListCols()} spacing={0}>
        <div className='Content2'>
            <Typography className="Title2">
                {props.dados.Name}
            </Typography>
                <Button variant="outlined" className="ViewButton2">
                    <Link to={
                                {
                                    pathname: props.dados.Link,
                                    state: {
                                        value: props.dados.Value
                                    }
                                }
                            }>Ler Mais</Link>
                </Button>
        </div>
        {(props.dados.Items) && props.dados.Items.map((tile) => (
          <GridListTile key={tile.img} className="Media2">
              {tile.img && (<img width="100%" src={`https://inaarees.gov.ao/backend/u/${tile.img}`} alt={tile.titulo} />)}
              <Link to={
                                {
                                    pathname: `${tile.link}`,
                                    state: {
                                        value: tile.value,
                                        title: tile.titulo,
                                        span: tile.span,
                                    }
                                }
                      }>
                <div className="MediaCaption2">
                    <span>{tile.titulo} <br></br><br></br> KZ {tile.span}</span>
                    
                    <IconButton aria-label={`info about ${tile.titulo}`} className={classes.icon}>
                      <ArrowForwardIosIcon />
                    </IconButton>
                </div>
            </Link>
          </GridListTile>
                    ))}
      </GridList>
    </div>
   
  );
}
export default withWidth()(NewGrid);
